// Fucntional component for footer with copyright notice and switch for toggling light/dark mode

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState, useContext } from "react";
import { faMoon } from "@fortawesome/free-solid-svg-icons";
import ReactSwitch from "react-switch";
import { ThemeContext } from "../App";

export const Footer = () => {
    const [windowDimenion, detectHW] = useState({
        winWidth: window.innerWidth,
        winHeight: window.innerHeight,
    });

    const { toggleTheme, theme } = useContext(ThemeContext);

    // Getting window size so that switch size may be adjusted
    const detectSize = () => {
        detectHW({
        winWidth: window.innerWidth,
        winHeight: window.innerHeight,
        });
    };

    useEffect(() => {
        window.addEventListener("resize", detectSize);

        return () => {
            window.removeEventListener("resize", detectSize);
        };

    }, [windowDimenion]);

    const DesktopWidth = 56;
    const DesktopHeight = 28;

    const MobileWidth = 42;
    const MobileHeight = 21;

    return (
        <div className="footer" id={theme}>
            <h3>© TeamQ 2022-2023, All rights reserved.</h3>

            <div className="footer--right">
                <FontAwesomeIcon
                    className="footer--moon icon"
                    icon={faMoon}
                    id={theme}
                />
                {/* Switch for toggling dark/light mode. Switch size is adjusted according to screen size */}
                <ReactSwitch
                    className="footer--switch"
                    checked={theme === "dark"}
                    offColor={"#769FCD"}
                    width={windowDimenion.winWidth < 600 ? MobileWidth : DesktopWidth}
                    height={windowDimenion.winWidth < 600 ? MobileHeight : DesktopHeight}
                    handleDiameter={
                        windowDimenion.winWidth < 600 ? MobileHeight - 2 : DesktopHeight - 2
                    }
                    onChange={toggleTheme}
                />
            </div>
        </div>
    );
};
